export default `
  @font-face {
    font-family: 'Maax';
    font-style: normal;
    font-weight: 100;
    src: url('https://dtxh53x5zi43j.cloudfront.net/fonts/maax/regular-205tf.woff2') format('woff2'),
        url('https://dtxh53x5zi43j.cloudfront.net/fonts/maax/regular-205tf.woff') format('woff');
  }

  @font-face {
    font-family: 'GT-Pressura';
    font-style: normal;
    src: url('https://dtxh53x5zi43j.cloudfront.net/fonts/gt-pressura/regular.woff2') format('woff2'),
        url('https://dtxh53x5zi43j.cloudfront.net/fonts/gt-pressura/regular.woff') format('woff');
  }

  @font-face {
    font-family: 'Maax-Bold';
    font-style: normal;
    src: url("https://assets.apostrophe.com/img/fonts/Maax+-+Bold-205TF.woff2") format("woff2"), url("https://assets.apostrophe.com/img/fonts/Maax+-+Bold-205TF.woff") format("woff");
    font-display: swap;
  }

  @font-face {
    font-family: 'Maax-Light';
    font-style: normal;
    src: url("https://assets.apostrophe.com/img/fonts/Maax+-+Light-205TF.woff2") format("woff2"), url("https://assets.apostrophe.com/img/fonts/Maax+-+Light-205TF.woff") format("woff");
    font-display: swap;
  }

  @font-face {
    font-family: 'Maax-Medium-Italic';
    font-style: normal;
    src: url("https://assets.apostrophe.com/img/fonts/Maax+-+Medium+Italic-205TF.woff2") format("woff2"), url("https://assets.apostrophe.com/img/fonts/Maax+-+Medium+Italic-205TF.woff") format("woff");
    font-display: swap;
  }

  @font-face {
    font-family: 'Maax-Medium';
    font-style: normal;
    src: url("https://assets.apostrophe.com/img/fonts/Maax+-+Medium-205TF.woff2") format("woff2"), url("https://assets.apostrophe.com/img/fonts/Maax+-+Medium-205TF.woff") format("woff");
    font-display: swap;
  }
`;
